

function getCookie(name) {
  const cookieString = document.cookie;
  const cookies = cookieString.split('; ');
  
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split('=');
    const cookieName = cookie[0];
    const cookieValue = cookie[1];
    
    if (cookieName === name) {
      return decodeURIComponent(cookieValue); // Decode the value if needed
    }
  }
  
  return null; // Return null if the cookie with the specified name is not found
}

const userHasPurchased = getCookie("userHasPurchased");


document.addEventListener("DOMContentLoaded", function() {
  var promoBannerDesktop = document.querySelector('.promo-banner-desktop');
  var promoBannerMobile = document.querySelector('.promo-banner-mobile'); 
  var showPromoBanner = document.querySelector('.promo-banner-desktop').getAttribute("data-show-promo-banner");
  console.log(`SPM: ${showPromoBanner}`)
  
  if (userHasPurchased === "true" && showPromoBanner === "false") {
    if (promoBannerDesktop) {
      promoBannerDesktop.style.display = "none";
    }
    if (promoBannerMobile) {
      promoBannerMobile.style.display = "none";
    }
  } else if (userHasPurchased === "true" && showPromoBanner === "true") {
    if (promoBannerDesktop) {
      promoBannerDesktop.style.display = "block";
    }
    if (promoBannerMobile) {
      promoBannerMobile.style.display = "block";
    }
  } else if (promoBannerDesktop || promoBannerMobile) { 
    
    if (promoBannerDesktop) { 
      promoBannerDesktop.addEventListener('click', function (event){
        let formId = promoBannerDesktop.getAttribute("data-form-id");
        window._klOnsite = window._klOnsite || []; 
        window._klOnsite.push(['openForm', formId]);
      });
    }
    
    if (promoBannerMobile) { 
      promoBannerMobile.addEventListener('click', function (event){
        let formId = promoBannerMobile.getAttribute("data-form-id");
        window._klOnsite = window._klOnsite || []; 
        window._klOnsite.push(['openForm', formId]);
      });
    }
  } 
});

